import { Component } from '@angular/core';

@Component({
	selector: 'app-reservation-summary-accommodation-service-dialog',
	templateUrl: './reservation-summary-accomodation-service-dialog.component.html',
	styleUrls: ['./reservation-summary-accomodation-service-dialog.component.scss'],
})
export class ReservationSummaryAccomodationServiceDialogComponent {
	constructor() {}
}
